export default __webpack_public_path__ + "static/media/Pilgrim's Gloves of the Green Ones.ec3e6322.jpg";